"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from "next/navigation";
import { Box, Text, HStack, VisuallyHidden, Link, Flex } from "@chakra-ui/react";
import NextImage from "next/image";
import { Headings } from "../data/data";
import NextLink from "@/components/custom-next-link";
import Heading from "./heading";
import ReportAddress from "./report-address";
export type Route = {
  label: string;
  href: string;
};
export const ROUTES = {
  MAP_RISK: {
    label: "Map & Risks",
    href: "/"
  },
  PREPARE: {
    label: "Prepare",
    href: "/prepare"
  },
  ABOUT_US: {
    label: "About Us",
    href: "/about"
  }
} as const;
const NAV_LINKS: Route[] = [ROUTES.MAP_RISK, ROUTES.PREPARE, ROUTES.ABOUT_US];
interface HomeHeaderProps {
  searchedAddress: string | null;
  isSearchComplete: boolean;
  onHomeIconClick: () => void;
  queryString?: string;
  children: React.ReactNode;
}
const HomeHeader = t0 => {
  const $ = _c(40);
  const {
    searchedAddress,
    isSearchComplete,
    onHomeIconClick,
    queryString: t1,
    children
  } = t0;
  const queryString = t1 === undefined ? "" : t1;
  const headingData = Headings.home;
  const router = useRouter();
  const pathname = usePathname();
  let t2;
  if ($[0] !== queryString) {
    t2 = href => {
      if (!queryString) {
        return href;
      }
      return `${href}?${queryString}`;
    };
    $[0] = queryString;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const getNavigationHref = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: "2",
      "2xl": "3"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: "column-reverse",
      "2xl": "row"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: "flex-start",
      "2xl": "center"
    };
    t6 = {
      base: "2",
      "2xl": "4"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      base: "column",
      md: "row"
    };
    t8 = {
      base: "flex-start",
      md: "center"
    };
    t9 = {
      base: "2",
      md: "4"
    };
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== isSearchComplete || $[10] !== searchedAddress) {
    t10 = <Box hideBelow="xl" flexShrink={0}>{isSearchComplete ? <ReportAddress searchedAddress={searchedAddress} /> : <Heading headingData={headingData} />}</Box>;
    $[9] = isSearchComplete;
    $[10] = searchedAddress;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      base: "full",
      md: "auto"
    };
    t12 = {
      md: "1"
    };
    $[12] = t11;
    $[13] = t12;
  } else {
    t11 = $[12];
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      base: "full"
    };
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== children) {
    t14 = <Flex alignItems="center" gap="2" width={t11} flex={t12}><Box width={t13}>{children}</Box></Flex>;
    $[15] = children;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      base: "3",
      md: "5"
    };
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== getNavigationHref || $[19] !== pathname) {
    t16 = NAV_LINKS.map(link => {
      const isActive = pathname === link.href;
      return <NextLink key={link.href} href={getNavigationHref(link.href)} fontSize={{
        base: "sm",
        md: "md"
      }} color={isActive ? "pageBackground" : "white"} backgroundColor={isActive ? "white" : "transparent"} fontWeight={isActive ? "bold" : "normal"} borderBottom={isActive ? "[2px solid white]" : "[2px solid transparent]"} py="1.5" px="2.5" borderRadius="md" cursor="button" textDecoration="none" whiteSpace="nowrap">{link.label}</NextLink>;
    });
    $[18] = getNavigationHref;
    $[19] = pathname;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t16) {
    t17 = <HStack as="nav" gap={t15} overflowX="auto">{t16}</HStack>;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t10 || $[24] !== t14 || $[25] !== t17) {
    t18 = <Flex direction={t7} alignItems={t8} gap={t9} flex="1">{t10}{t14}{t17}</Flex>;
    $[23] = t10;
    $[24] = t14;
    $[25] = t17;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      base: "3",
      md: "5"
    };
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== onHomeIconClick || $[29] !== router) {
    t20 = event => {
      event.preventDefault();
      onHomeIconClick();
      router.push("/");
    };
    $[28] = onHomeIconClick;
    $[29] = router;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <HStack align="baseline"><NextImage width={142} height={28} alt="SafeHome logo" role="img" src="/images/SFSafeHome-fulllogo.svg" priority={true} /><VisuallyHidden>SafeHome</VisuallyHidden></HStack>;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t20) {
    t22 = <Link as="a" color="white" href="/" cursor="button" textDecoration="none" onClick={t20}>{t21}</Link>;
    $[32] = t20;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Text textStyle="textPrerelease" layerStyle="prerelease">Beta</Text>;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t22) {
    t24 = <Flex alignItems="center" gap={t19} flexShrink={0}><HStack align="start" gap="1" flexShrink={0}>{t22}{t23}</HStack></Flex>;
    $[35] = t22;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== t18 || $[38] !== t24) {
    t25 = <Box as="header" bgGradient="blue" py={t3} px="6" w="full"><Flex direction={t4} justifyContent="space-between" alignItems={t5} gap={t6}>{t18}{t24}</Flex></Box>;
    $[37] = t18;
    $[38] = t24;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  return t25;
};
export default HomeHeader;